module.exports = __webpack_public_path__ + "56e614a2458e9a76a37822f750d4a6a7.jpg";